import { render, staticRenderFns } from "./TopWorkflowPeople.vue?vue&type=template&id=6918740a"
import script from "./TopWorkflowPeople.vue?vue&type=script&lang=js"
export * from "./TopWorkflowPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports